import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ClienteAreaPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(true);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simulação de login/registro
    if (isLoggingIn) {
      // Simulação de login bem-sucedido
      setMessage({ text: 'Login realizado com sucesso! Redirecionando...', type: 'success' });
      setTimeout(() => {
        setMessage({ text: 'Esta é uma demonstração. Em um ambiente real, você seria redirecionado para sua área de cliente.', type: 'info' });
      }, 2000);
    } else {
      // Simulação de registro bem-sucedido
      setMessage({ text: 'Cadastro realizado com sucesso! Verifique seu e-mail para ativar sua conta.', type: 'success' });
    }
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    // Simulação de recuperação de senha
    setMessage({ text: 'Instruções de recuperação de senha enviadas para seu e-mail.', type: 'success' });
    setTimeout(() => {
      setForgotPassword(false);
    }, 3000);
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#1A3A5F] to-[#4D8BC9] text-white">
        <div className="container mx-auto px-4 py-16">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Área do Cliente</h1>
            <p className="text-xl mb-8">
              Acesse sua área exclusiva para gerenciar projetos, visualizar relatórios e acompanhar serviços
            </p>
          </motion.div>
        </div>
      </section>

      {/* Login/Register Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-md mx-auto">
            {forgotPassword ? (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="p-8">
                  <h2 className="text-2xl font-bold mb-6 text-[#1A3A5F] text-center">Recuperar Senha</h2>
                  
                  {message.text && (
                    <div className={`mb-6 p-3 rounded ${message.type === 'success' ? 'bg-green-100 text-green-700' : message.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}`}>
                      {message.text}
                    </div>
                  )}
                  
                  <form onSubmit={handleForgotPassword}>
                    <div className="mb-6">
                      <label htmlFor="reset-email" className="block text-gray-700 font-medium mb-2">E-mail</label>
                      <input
                        type="email"
                        id="reset-email"
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]"
                        placeholder="Seu e-mail cadastrado"
                        value={resetEmail}
                        onChange={(e) => setResetEmail(e.target.value)}
                        required
                      />
                    </div>
                    
                    <div className="flex flex-col space-y-4">
                      <button
                        type="submit"
                        className="w-full bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold py-3 px-4 rounded-md transition-colors"
                      >
                        Enviar Instruções
                      </button>
                      
                      <button
                        type="button"
                        className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-3 px-4 rounded-md transition-colors"
                        onClick={() => {
                          setForgotPassword(false);
                          setMessage({ text: '', type: '' });
                        }}
                      >
                        Voltar
                      </button>
                    </div>
                  </form>
                </div>
              </motion.div>
            ) : (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="flex">
                  <button
                    className={`flex-1 py-4 text-center font-bold ${isLoggingIn ? 'bg-[#1A3A5F] text-white' : 'bg-gray-100 text-gray-700'}`}
                    onClick={() => {
                      setIsLoggingIn(true);
                      setMessage({ text: '', type: '' });
                    }}
                  >
                    Login
                  </button>
                  <button
                    className={`flex-1 py-4 text-center font-bold ${!isLoggingIn ? 'bg-[#1A3A5F] text-white' : 'bg-gray-100 text-gray-700'}`}
                    onClick={() => {
                      setIsLoggingIn(false);
                      setMessage({ text: '', type: '' });
                    }}
                  >
                    Cadastro
                  </button>
                </div>
                
                <div className="p-8">
                  <h2 className="text-2xl font-bold mb-6 text-[#1A3A5F] text-center">
                    {isLoggingIn ? 'Acesse sua conta' : 'Crie sua conta'}
                  </h2>
                  
                  {message.text && (
                    <div className={`mb-6 p-3 rounded ${message.type === 'success' ? 'bg-green-100 text-green-700' : message.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}`}>
                      {message.text}
                    </div>
                  )}
                  
                  <form onSubmit={handleSubmit}>
                    {!isLoggingIn && (
                      <div className="mb-6">
                        <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Nome Completo</label>
                        <input
                          type="text"
                          id="name"
                          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]"
                          placeholder="Seu nome completo"
                          required={!isLoggingIn}
                        />
                      </div>
                    )}
                    
                    <div className="mb-6">
                      <label htmlFor="email" className="block text-gray-700 font-medium mb-2">E-mail</label>
                      <input
                        type="email"
                        id="email"
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]"
                        placeholder="Seu e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    
                    {!isLoggingIn && (
                      <div className="mb-6">
                        <label htmlFor="company" className="block text-gray-700 font-medium mb-2">Empresa</label>
                        <input
                          type="text"
                          id="company"
                          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]"
                          placeholder="Nome da sua empresa"
                          required={!isLoggingIn}
                        />
                      </div>
                    )}
                    
                    <div className="mb-6">
                      <label htmlFor="password" className="block text-gray-700 font-medium mb-2">Senha</label>
                      <input
                        type="password"
                        id="password"
                        className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]"
                        placeholder={isLoggingIn ? "Sua senha" : "Crie uma senha forte"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    
                    {!isLoggingIn && (
                      <div className="mb-6">
                        <label htmlFor="confirm-password" className="block text-gray-700 font-medium mb-2">Confirmar Senha</label>
                        <input
                          type="password"
                          id="confirm-password"
                          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#4D8BC9]"
                          placeholder="Confirme sua senha"
                          required={!isLoggingIn}
                        />
                      </div>
                    )}
                    
                    {isLoggingIn && (
                      <div className="flex justify-between items-center mb-6">
                        <div className="flex items-center">
                          <input
                            type="checkbox"
                            id="remember"
                            className="h-4 w-4 text-[#4D8BC9] focus:ring-[#4D8BC9] border-gray-300 rounded"
                          />
                          <label htmlFor="remember" className="ml-2 block text-sm text-gray-700">
                            Lembrar-me
                          </label>
                        </div>
                        <button
                          type="button"
                          className="text-sm text-[#4D8BC9] hover:text-[#1A3A5F]"
                          onClick={() => {
                            setForgotPassword(true);
                            setMessage({ text: '', type: '' });
                          }}
                        >
                          Esqueceu a senha?
                        </button>
                      </div>
                    )}
                    
                    <button
                      type="submit"
                      className="w-full bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold py-3 px-4 rounded-md transition-colors"
                    >
                      {isLoggingIn ? 'Entrar' : 'Cadastrar'}
                    </button>
                  </form>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Recursos Exclusivos para Clientes</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Acesse recursos exclusivos e gerencie seus projetos com o Grupo M7 CORP de forma eficiente e prática.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* Feature 1 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F] text-center">Relatórios e Documentos</h3>
              <p className="text-gray-700 text-center">
                Acesse todos os seus relatórios, laudos técnicos e documentação de projetos em um só lugar, com histórico completo e download disponível.
              </p>
            </motion.div>

            {/* Feature 2 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F] text-center">Acompanhamento de Projetos</h3>
              <p className="text-gray-700 text-center">
                Acompanhe o status de seus projetos em tempo real, com cronogramas, marcos e atualizações sobre o andamento de cada etapa.
              </p>
            </motion.div>

            {/* Feature 3 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F] text-center">Agendamento de Serviços</h3>
              <p className="text-gray-700 text-center">
                Solicite novos serviços, agende visitas técnicas e acompanhe o calendário de manutenções programadas de forma simples e rápida.
              </p>
            </motion.div>

            {/* Feature 4 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F] text-center">Suporte Técnico</h3>
              <p className="text-gray-700 text-center">
                Acesse nosso suporte técnico exclusivo para clientes, com atendimento prioritário e acompanhamento de chamados em tempo real.
              </p>
            </motion.div>

            {/* Feature 5 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="w-16 h-16 bg-[#1A3A5F] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F] text-center">Biblioteca Técnica</h3>
              <p className="text-gray-700 text-center">
                Acesse nossa biblioteca técnica exclusiva com normas, procedimentos, manuais e materiais de referência para consulta.
              </p>
            </motion.div>

            {/* Feature 6 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="w-16 h-16 bg-[#4D8BC9] rounded-full flex items-center justify-center mb-4 mx-auto">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#1A3A5F] text-center">Indicadores e Dashboards</h3>
              <p className="text-gray-700 text-center">
                Visualize indicadores de desempenho, estatísticas e dashboards personalizados para acompanhar seus projetos e serviços.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* App Preview Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between max-w-5xl mx-auto">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="md:w-1/2 mb-10 md:mb-0 md:pr-10"
            >
              <h2 className="text-3xl font-bold mb-6 text-[#1A3A5F]">Acesse de Qualquer Lugar</h2>
              <p className="text-lg text-gray-700 mb-6">
                Nossa plataforma é totalmente responsiva e pode ser acessada de qualquer dispositivo, seja computador, tablet ou smartphone.
              </p>
              <p className="text-lg text-gray-700 mb-8">
                Em breve, disponibilizaremos também nosso aplicativo exclusivo para clientes, com todas as funcionalidades da plataforma web e recursos adicionais.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button className="bg-[#1A3A5F] hover:bg-[#4D8BC9] text-white font-bold py-3 px-6 rounded-md transition-colors flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  Acessar Plataforma
                </button>
                <button className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-3 px-6 rounded-md transition-colors flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Saiba Mais
                </button>
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="md:w-1/2"
            >
              <div className="bg-gray-200 rounded-lg p-4 shadow-lg">
                <div className="bg-white rounded-lg overflow-hidden shadow-md">
                  <div className="bg-[#1A3A5F] text-white p-4 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="font-bold">Portal do Cliente - M7 CORP</span>
                  </div>
                  <div className="p-6">
                    <div className="flex justify-between items-center mb-6">
                      <h3 className="text-xl font-bold text-[#1A3A5F]">Dashboard</h3>
                      <div className="text-sm bg-green-100 text-green-800 px-2 py-1 rounded">Online</div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4 mb-6">
                      <div className="bg-gray-100 p-4 rounded">
                        <div className="text-sm text-gray-500 mb-1">Projetos Ativos</div>
                        <div className="text-2xl font-bold text-[#1A3A5F]">12</div>
                      </div>
                      <div className="bg-gray-100 p-4 rounded">
                        <div className="text-sm text-gray-500 mb-1">Relatórios</div>
                        <div className="text-2xl font-bold text-[#1A3A5F]">36</div>
                      </div>
                      <div className="bg-gray-100 p-4 rounded">
                        <div className="text-sm text-gray-500 mb-1">Próxima Visita</div>
                        <div className="text-lg font-bold text-[#1A3A5F]">15/07</div>
                      </div>
                      <div className="bg-gray-100 p-4 rounded">
                        <div className="text-sm text-gray-500 mb-1">Chamados</div>
                        <div className="text-2xl font-bold text-[#1A3A5F]">2</div>
                      </div>
                    </div>
                    
                    <div className="mb-6">
                      <h4 className="font-bold text-gray-700 mb-2">Projetos Recentes</h4>
                      <div className="space-y-2">
                        <div className="bg-gray-50 p-3 rounded flex justify-between items-center">
                          <span>Inspeção NR-13</span>
                          <span className="text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded">Em andamento</span>
                        </div>
                        <div className="bg-gray-50 p-3 rounded flex justify-between items-center">
                          <span>Análise de Integridade</span>
                          <span className="text-sm bg-green-100 text-green-800 px-2 py-1 rounded">Concluído</span>
                        </div>
                        <div className="bg-gray-50 p-3 rounded flex justify-between items-center">
                          <span>Treinamento NR-35</span>
                          <span className="text-sm bg-yellow-100 text-yellow-800 px-2 py-1 rounded">Agendado</span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="flex justify-center">
                      <button className="text-[#4D8BC9] hover:text-[#1A3A5F] font-bold">
                        Ver todos os projetos →
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">O Que Nossos Clientes Dizem</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Veja o que nossos clientes falam sobre a experiência de utilizar nossa plataforma.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {/* Testimonial 1 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mr-4">
                  <span className="text-white font-bold">RP</span>
                </div>
                <div>
                  <h4 className="font-bold text-[#1A3A5F]">Ricardo Pereira</h4>
                  <p className="text-sm text-gray-600">Gerente de Manutenção, Petroquímica SA</p>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "A plataforma do cliente do Grupo M7 CORP revolucionou a forma como gerenciamos nossos projetos de inspeção. Tudo centralizado, com acesso rápido aos relatórios e histórico completo."
              </p>
              <div className="mt-4 flex">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              </div>
            </motion.div>

            {/* Testimonial 2 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#4D8BC9] rounded-full flex items-center justify-center mr-4">
                  <span className="text-white font-bold">CS</span>
                </div>
                <div>
                  <h4 className="font-bold text-[#1A3A5F]">Carla Santos</h4>
                  <p className="text-sm text-gray-600">Coordenadora de Segurança, Indústria Brasileira</p>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "O acesso rápido aos relatórios e certificados facilita muito nosso trabalho durante as auditorias. A interface é intuitiva e o suporte técnico é excelente quando precisamos de ajuda."
              </p>
              <div className="mt-4 flex">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              </div>
            </motion.div>

            {/* Testimonial 3 */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-md p-6"
            >
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-[#1A3A5F] rounded-full flex items-center justify-center mr-4">
                  <span className="text-white font-bold">MA</span>
                </div>
                <div>
                  <h4 className="font-bold text-[#1A3A5F]">Marcos Almeida</h4>
                  <p className="text-sm text-gray-600">Diretor de Operações, Energia Total</p>
                </div>
              </div>
              <p className="text-gray-700 italic">
                "A possibilidade de acompanhar os projetos em tempo real e agendar serviços diretamente pela plataforma otimizou nossos processos internos. Recomendo fortemente."
              </p>
              <div className="mt-4 flex">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-yellow-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-300" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1A3A5F] text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Pronto para Começar?</h2>
            <p className="text-xl mb-8">
              Crie sua conta agora e tenha acesso a todos os recursos exclusivos da nossa plataforma.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link 
                to="/cliente-area" 
                className="bg-white text-[#1A3A5F] hover:bg-gray-100 font-bold px-8 py-3 rounded-md transition-colors"
              >
                Criar Conta
              </Link>
              <Link 
                to="/contato" 
                className="bg-transparent border-2 border-white hover:bg-white hover:text-[#1A3A5F] text-white font-bold px-8 py-3 rounded-md transition-colors"
              >
                Falar com um Consultor
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl font-bold mb-4 text-[#1A3A5F]">Perguntas Frequentes</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Tire suas dúvidas sobre nossa plataforma e área do cliente.
            </p>
          </motion.div>

          <div className="max-w-3xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="mb-6"
            >
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Como posso criar uma conta?</h3>
                  <p className="text-gray-700">
                    Para criar uma conta, basta clicar no botão "Cadastro" na área de login e preencher o formulário com seus dados. Após o cadastro, nossa equipe irá validar suas informações e ativar sua conta em até 24 horas úteis.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
              className="mb-6"
            >
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Quem pode acessar a área do cliente?</h3>
                  <p className="text-gray-700">
                    A área do cliente é exclusiva para empresas que contrataram serviços do Grupo M7 CORP. Cada empresa pode ter múltiplos usuários com diferentes níveis de acesso, conforme a necessidade.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
              className="mb-6"
            >
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Como recupero minha senha?</h3>
                  <p className="text-gray-700">
                    Para recuperar sua senha, clique em "Esqueceu a senha?" na tela de login e siga as instruções enviadas para seu e-mail cadastrado. Se não receber o e-mail, verifique sua caixa de spam ou entre em contato com nosso suporte.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
              className="mb-6"
            >
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Os relatórios podem ser baixados?</h3>
                  <p className="text-gray-700">
                    Sim, todos os relatórios e documentos disponíveis na plataforma podem ser baixados em formato PDF. Alguns documentos também estão disponíveis em outros formatos, como Excel ou Word, dependendo do tipo de conteúdo.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-3 text-[#1A3A5F]">Como solicito suporte técnico?</h3>
                  <p className="text-gray-700">
                    O suporte técnico pode ser solicitado diretamente pela plataforma, através da seção "Suporte", ou pelo e-mail suporte@m7corp.com.br. Nosso tempo de resposta é de até 4 horas úteis para clientes com contrato ativo.
                  </p>
                </div>
              </div>
            </motion.div>

            <div className="text-center mt-8">
              <Link 
                to="/faq" 
                className="text-[#4D8BC9] hover:text-[#1A3A5F] font-bold"
              >
                Ver todas as perguntas →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ClienteAreaPage;
